<template>
  <simple-page>
    <template v-slot:pageItem>
      <breadcrumb :items="breadcrumbItems" />
      <pending-items-internal :title="false" />
    </template>
    <template v-slot:pageTitle>
      <h1 class="text-upper-case">Pending Underwriting List</h1>
      <button class="clear-search" @click="clearFilter">Clear Search</button>
    </template>
    <template v-slot:filter>
      <pending-underwriting-filter :filters="filterQuery" @onSearch="filterData" />
    </template>
    <template v-slot:topPagination>
      <div
          class="top-pagination"
      >
        <pagination :rows.sync="rows" :filters="filterQuery"  :underwritingStatus="true" />
      </div>
    </template>
    <template v-slot:table>
      <clients-data :memberLists="rows" :underwritingStatus="true"/>
      <pagination :rows.sync="rows" :filters="filterQuery"  :underwritingStatus="true" />
    </template>
  </simple-page>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import ClientsData from "@/views/MemberList/partials/ClientsData.vue";
import PendingItemsInternal from "../Dashboard/partials/PendingItemsInternal.vue";
import PendingUnderwritingFilter from "./partials/PendingUnderwritingFilter";
export default {
  components: { PendingItemsInternal, PendingUnderwritingFilter, ClientsData },
  name: "PendingUnderwritingRepList",
  data: () => ({
    rows: [],
    columns: [
      { label: "System Id" },
      { label: "Name" },
      { label: "Dates" },
      { label: "Rep & Employee" },
      { label: "Premiums" },
      { label: "Actions" },
    ],
    filterQuery: {
      first_name: "",
      last_name: "",
      agent_code: "",
      status: "",
      enrollment_date: "",
      state: "",
      effective_date: "",
      enrollment_from: "",
      enrollment_to: "",
      group_id: "",
      rep_id: "",
      // page_size: 30,
    },
    breadcrumbItems: [{ title: "Renewals", active: true }],
  }),
  methods: {
    clearFilter() {
      this.filterQuery = {
        first_name: "",
        last_name: "",
        agent_code: "",
        status: "",
        enrollment_date: "",
        state: "",
        effective_date: "",
        enrollment_from: "",
        enrollment_to: "",
        group_id: "",
        rep_id: "",
        policy_id: '',
        page_size: 10,
      };
      this.getPendingSignatures();
    },
    filterData(filters) {
      this.filterQuery = filters;
      this.getPendingSignatures(this.filterQuery);
    },
    getPendingSignatures(filters = null) {
      let url;
      let loader = this.$loading.show();
      let baseUrl = `v2/get-members?pending_underwriting=1`
      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = `${baseUrl}&${filterUrl}`;
      } else {
        url = `${baseUrl}&page_size=10`;
      }

      Api.get(url)
          .then((res) => {
            console.log(res)
            this.rows = res.data;
          })
          .catch(() => {
            this.rows = [];
          })
          .finally(() => {
            loader.hide();
          });
    },
  },
  created() {
    this.getPendingSignatures();
  },
};
</script>
<style src="@/assets/css/viewclients.css"></style>
